import { fetchNotifications } from "signoxe/actions/notification";
import {
  fetchAssets,
  fetchCalendarAssets,
  fetchFeedAssets,
  fetchWebAssets,
  fetchCampaigns,
} from "./asset";
import {
  fetchDeviceGroups,
  fetchDeviceUngroupedWrapers,
  fetchDeviceScreenShots,
  fetchUngroupedDevices,
} from "./device";
import { fetchPlaylists } from "./playlist";
import { fetchPlaylistsV2 } from "./playlistV2";
import { fetchChannels } from "./channel";
import { fetchProfile } from "./profile";
import { fetchTickerSeries } from "./ticker";
import { fetchTags } from "./tagActions";
import { fetchUserReports } from "./user_reports";
import {
  fetchWebAssetTemplates,
  fetchCustomTemplates,
  fetchScrollerTemplates,
} from "./webAssetTemplate";

import {get_device_pairing_list, get_license_list} from './deviceActions';

/**
 * Fetches all resources in a single call.
 */
export const fetchAll = () => (dispatch) => {
  // Fetch assets and then fetch web, calendar and feed assets as they augment the main asset list.
  dispatch(fetchAssets(true))
    // .then(() => dispatch(fetchWebAssets()))
    // .then(() => dispatch(fetchCalendarAssets()))
    .then(() => dispatch(fetchFeedAssets()));
  // Fetch device screen shots only after fetching all device groups.
  dispatch(fetchDeviceGroups(true)).then(() =>
    dispatch(fetchDeviceScreenShots())
  );
  dispatch(fetchDeviceUngroupedWrapers(true)).then(() =>
    dispatch(fetchDeviceScreenShots())
  );
  dispatch(fetchCampaigns(true));
  dispatch(fetchUngroupedDevices(true));
  dispatch(fetchPlaylistsV2(true));
  dispatch(fetchPlaylists(true));
  dispatch(fetchChannels(true));
  dispatch(fetchTickerSeries(true));
  dispatch(fetchWebAssetTemplates(true));
  dispatch(fetchCustomTemplates(true));
  dispatch(fetchScrollerTemplates(true));
  dispatch(fetchProfile(true));
  dispatch(fetchNotifications(true));
  dispatch(fetchTags(true));
  dispatch(fetchUserReports(true));

  dispatch(get_device_pairing_list());
  dispatch(get_license_list());
};

export default fetchAll;

export const fetchAllAssets = () => (dispatch) => {
  // Fetch assets and then fetch web, calendar and feed assets as they augment the main asset list.
  dispatch(fetchAssets(true))
    // .then(() => dispatch(fetchWebAssets()))
    // .then(() => dispatch(fetchCalendarAssets()))
    .then(() => dispatch(fetchFeedAssets()));
  // Fetch device screen shots only after fetching all device groups.
 
};




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/fetchAll.js